import "rxjs/add/operator/toPromise";
import "rxjs/add/observable/interval";
import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {SnowridersComponent} from "./snowriders.component";
import {HomeComponent} from "./home.component";
import {FormsModule} from "@angular/forms";
import {PostEditComponent} from "./post-edit.component";
import {HttpModule} from "@angular/http";
import {FilterPipe} from "./filter.pipe";
import {PostComponent} from "./post.component";
import {HtmlObjectComponent} from "./html-object.component";
import {LoginComponent} from "./login.component";
import {IfLoggedInDirective} from "./if-logged-in.directive";
import {CookieService} from "ngx-cookie-service";
import {LogOffDirective} from "./log-off.directive";
import {HtmlObjectEditComponent} from "./html-object-edit.component";
import {QuillEditorModule} from "./ngx-quill-editor/quill-editor.module";
import {SnowridersService} from "./snowriders.service";
import {LogoComponent} from "./logo.component";

export const appRoutes: Routes = [
  {path: 'post/edit/:id', component: PostEditComponent},
  {path: 'post/create', component: PostEditComponent},
  {path: 'post/:id', component: PostComponent},
  {path: 'object/edit-html/:id', component: HtmlObjectEditComponent},
  {path: 'login', component: LoginComponent},
  {path: '', component: HomeComponent},
  {path: '**', component: HomeComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    HttpModule,
    QuillEditorModule,
  ],
  providers: [
    CookieService,
    SnowridersService,
  ],
  declarations: [
    FilterPipe,
    SnowridersComponent,
    PostEditComponent,
    PostComponent,
    HomeComponent,
    HtmlObjectComponent,
    HtmlObjectEditComponent,
    LoginComponent,
    IfLoggedInDirective,
    LogOffDirective,
    LogoComponent,
  ],
  bootstrap: [SnowridersComponent],
  exports: [
    RouterModule,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/snowriders.module.ts